import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=4ff334c6"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=4ff334c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports